import { Button } from "antd";
import { Can } from "@/shared/lib/casl";
import type { ChatAction } from "../../model";
import "./ai-chat-actions.scss";

export const AiChatActions = ({ actions }: { actions: ChatAction[] }) => {

  if (!actions || actions.length === 0) {
    return null;
  }

  const handleAction = (action: typeof actions[0]) => {
    action.onClick?.();
  };

  return (
    <div className="ai-chat-actions">
      {actions.map((action, index) => {
        const prev = actions[index - 1];
        const prevIsPrimary = (prev?.variant ?? "primary") === "primary";
        const variant = action.variant ?? (prevIsPrimary ? "secondary" : "primary");

        const btn = (
          <Button
            key={action.id}
            type={variant === "primary" ? "primary" : "default"}
            block
            disabled={action.disabled}
            onClick={() => handleAction(action)}
            className={variant === "secondary" ? "ai-chat-actions__btn--secondary" : undefined}
            style={{ height: "40px" }}
          >
            {action.label}
          </Button>
        );

        if (
          action.id === "return-to-work" ||
          action.id === "revoke-approval" ||
          action.id === "send-approval"
        ) {
          return (
            <Can key={action.id} I="edit" a="title_journals">
              {btn}
            </Can>
          );
        }

        if (action.id === "approve-title" || action.id === "reject-title") {
          return (
            <Can key={action.id} I="approve" a="title_journals">
              {btn}
            </Can>
          );
        }

        return btn;
      })}
    </div>
  );
};

